import { BestSellerItem } from "shared/catalog/BestSellersCatalog/BestSellerItem";
import { useBestSellersContext } from "shared/catalog/BestSellersCatalog/BestSellersContext/useBestSellersContext";

import { CatalogGrid } from "../CatalogGrid";

export const BestSellersCatalog = () => {
  const bestSellersEntries = useBestSellersContext();

  return (
    <CatalogGrid truncateOnTablet>
      {bestSellersEntries
        ?.filter(Boolean)
        ?.map((item, index) => <BestSellerItem key={index} item={item} />)}
    </CatalogGrid>
  );
};
